import { IconProps } from '.';

function Book({ style, className }: IconProps) {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 2 22 11'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      style={style}
    >
      <title>Book</title>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10 1.05884H14.611C15.377 1.05884 16 1.68184 16 2.44684V11.6698C16 12.4358 15.377 13.0588 14.611 13.0588H10C9.173 13.0588 8.5 13.7318 8.5 14.5588C8.5 14.8348 8.276 15.0588 8 15.0588C7.724 15.0588 7.5 14.8348 7.5 14.5588C7.5 13.7318 6.827 13.0588 6 13.0588H1.389C0.623 13.0588 0 12.4358 0 11.6698V2.44684C0 1.68184 0.623 1.05884 1.389 1.05884H6C6.821 1.05884 7.544 1.46084 8 2.07284C8.456 1.46084 9.179 1.05884 10 1.05884ZM6 12.0588H1.389C1.175 12.0588 1 11.8838 1 11.6698V2.44684C1 2.23284 1.175 2.05884 1.389 2.05884H6C6.827 2.05884 7.5 2.73184 7.5 3.55884V12.5598C7.082 12.2448 6.562 12.0588 6 12.0588ZM15 11.6698C15 11.8838 14.825 12.0588 14.611 12.0588H10C9.435 12.0588 8.919 12.2538 8.5 12.5708V3.55884C8.5 2.73184 9.173 2.05884 10 2.05884H14.611C14.825 2.05884 15 2.23284 15 2.44684V11.6698Z'
        fill='currentColor'
      />
    </svg>
  );
}

export default Book;
